import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const configuredFirebase = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const hasFirebaseConfig = Boolean(
  configuredFirebase.apiKey &&
  configuredFirebase.authDomain &&
  configuredFirebase.projectId &&
  configuredFirebase.appId
);

const firebaseConfig = hasFirebaseConfig
  ? configuredFirebase
  : {
      apiKey: 'local-development-key',
      authDomain: 'local-development.firebaseapp.com',
      projectId: 'local-development',
      storageBucket: 'local-development.appspot.com',
      messagingSenderId: '000000000000',
      appId: 'local-development-app',
    };

if (!hasFirebaseConfig) {
  console.warn(
    'Firebase configuration is missing. Authentication and data features are disabled until REACT_APP_FIREBASE_* variables are provided.'
  );
}

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;

